<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import type { HierarchyCustomizationDefinition } from 'header/types';

    interface Props {
        field: HierarchyCustomizationDefinition;
    }

    let { field }: Props = $props();

    const dispatch = createEventDispatcher();

    const onChange = (e: { currentTarget: HTMLInputElement }) => {
        dispatch('change', {
            field: {
                ...field,
                value: e.currentTarget.value.split(','),
            },
        });
    };
</script>

<input
    class="input"
    type="text"
    disabled={field.changeable === false}
    value={field.value}
    oninput={onChange}
/>

<style lang="scss" scoped>
    .input {
        width: 100%;
    }
</style>
